import type { SvgIconProps } from '@mui/material/SvgIcon';
import type { ReactNode } from 'react';
import { ApplovinIcon } from './ApplovinIcon';
import { Dv360Icon } from './Dv360Icon';
import { GoogleIcon } from './GoogleIcon';
import { InstagramIcon } from './InstagramIcon';
import { LinkedInIcon } from './LinkedInIcon';
import { MetaIcon } from './MetaIcon';
import { MicrosoftIcon } from './MicrosoftIcon';
import { MolocoIcon } from './MolocoIcon';
import { SnapchatIcon } from './SnapchatIcon';
import { TikTokIcon } from './TikTokIcon';
import { XIcon } from './XIcon';
import { YouTubeIcon } from './YouTubeIcon';

export const NETWORK_COLOR_KEYS = ['meta', 'google', 'linkedin', 'tiktok'] as const;

export type NetworkColorKey = (typeof NETWORK_COLOR_KEYS)[number];

const NETWORK_COLOR_KEY_BY_KEY: Record<string, NetworkColorKey> = {
  facebook: 'meta',
  meta: 'meta',
  instagram: 'meta',
  google: 'google',
  'google ads': 'google',
  dv360: 'google',
  youtube: 'google',
  linkedin: 'linkedin',
  tiktok: 'tiktok',
};

const NETWORK_ICON_BY_KEY: Record<string, (props: SvgIconProps) => ReactNode> = {
  facebook: MetaIcon,
  meta: MetaIcon,
  instagram: InstagramIcon,
  youtube: YouTubeIcon,
  google: GoogleIcon,
  'google ads': GoogleIcon,
  dv360: Dv360Icon,
  tiktok: TikTokIcon,
  linkedin: LinkedInIcon,
  twitter: XIcon,
  x: XIcon,
  microsoft: MicrosoftIcon,
  bing: MicrosoftIcon,
  applovin: ApplovinIcon,
  moloco: MolocoIcon,
  snapchat: SnapchatIcon,
};

export function networkIconFor(
  ...names: (string | null | undefined)[]
): ((props: SvgIconProps) => ReactNode) | undefined {
  for (const name of names) {
    const icon = name ? NETWORK_ICON_BY_KEY[name.toLowerCase()] : undefined;
    if (icon !== undefined) return icon;
  }
  return undefined;
}

export function networkColorKeyFor(
  ...names: (string | null | undefined)[]
): NetworkColorKey | undefined {
  for (const name of names) {
    const key = name ? NETWORK_COLOR_KEY_BY_KEY[name.toLowerCase()] : undefined;
    if (key !== undefined) return key;
  }
  return undefined;
}
